jQuery(function() {
  $("section.wysiwyg-content a").attr("target", "_blank");
});
